import { servicesUsers } from 'services';
import useQueryHookWrapper from 'hooks/use-query-hook-wrapper';
import { QueryConfig } from 'react-query';
import { TQueryDefWrapper } from 'types/network';
import { TGetUserActivityLogDetailResponse } from 'types/entities/user-activity-logs';

const useUserActivityLogDetail = (
    id: string,
    arg0?: QueryConfig<
        TQueryDefWrapper<TGetUserActivityLogDetailResponse>,
        string
    >,
) => {
    return useQueryHookWrapper<
        TQueryDefWrapper<TGetUserActivityLogDetailResponse>,
        string,
        { id: string }
    >({
        queryKey: `user-activity-log-detail`,
        queryFn: servicesUsers.getUserActivityLogDetail,
        queryConfig: arg0,
        values: { id },
    });
};

export default useUserActivityLogDetail;
